// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.navbar {
  position: sticky;
  top: 0;
  z-index: 9999;
  background-color: var(--e-global-color-primary);
  color: var(--e-global-color-b7be4da);
}

.navbar-brand {
  font-size: 1rem;
  color: var(--e-global-color-b7be4da);
}

.nav-link {
  color: var(--e-global-color-b7be4da);
}

.nav-link:hover {
  color: var(--e-global-color-63d5b28);
}

.dropdown-menu {
  background-color: #ffffff;
  color: var(--e-global-color-text);
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12);
  padding: 6px;
  min-width: 180px;
}

.dropdown-item {
  color: var(--e-global-color-text);
  border-radius: 10px;
  padding: 10px 12px;
  display: flex;
  align-items: center;
  gap: 10px;
}
.dropdown-item:hover {
  background: #f7f8fb;
  color: #111827;
}

.nav-action.app-button {
  color: #ffffff;
  border-color: rgba(255, 255, 255, 0.35);
  background: transparent;
  box-shadow: none;
}
.nav-action.app-button:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.5);
  color: #ffffff;
}

.nav-action__icon.app-button {
  padding: 8px 10px;
}

.nav-action--filled.app-button {
  background: #ffffff;
  color: var(--e-global-color-primary);
  border-color: #ffffff;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.14);
}

.nav-close.app-button {
  color: #ffffff;
  padding: 0;
  background: transparent;
  border: none;
  box-shadow: none;
}
.nav-close.app-button:hover {
  color: var(--e-global-color-63d5b28);
}

.details-header-banner {
  background-color: var(--e-global-color-primary) !important;
  background: url('event-image.png') no-repeat center center;
  background-size: cover;
  height: 300px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 2rem;
}

.details-header-banner h1 {
  font-size: 3rem;
  margin: 0;
}

.mobile-sidenav {
  position: fixed;
  top: 0;
  left: 0;
  width: 260px;
  height: 100%;
  background-color: var(--e-global-color-primary);
  color: #fff;
  overflow-y: auto;
  transform: translateX(-100%);
  transition: transform 0.3s ease-in-out;
  z-index: 1050;
}
.mobile-sidenav.open {
  transform: translateX(0);
}
.mobile-sidenav .nav-link {
  color: #fff;
  padding: 0.75rem 0;
}
.mobile-sidenav .nav-link:hover {
  color: var(--e-global-color-63d5b28);
}

/* háttér-overlay */
.sidenav-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1040;
}

/* rejtett-desktop nav-linkek */
@media (max-width: 991.98px) {
  .navbar .ml-auto {
    display: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./projects/public/src/app/components/public-header/public-header.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,gBAAA;EACA,MAAA;EACA,aAAA;EACA,+CAAA;EACA,oCAAA;AAEF;;AACA;EACE,eAAA;EACA,oCAAA;AAEF;;AACA;EACE,oCAAA;AAEF;;AACA;EACE,oCAAA;AAEF;;AACA;EACE,yBAAA;EACA,iCAAA;EACA,qCAAA;EACA,mBAAA;EACA,2CAAA;EACA,YAAA;EACA,gBAAA;AAEF;;AACA;EACE,iCAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAEF;AAAE;EACE,mBAAA;EACA,cAAA;AAEJ;;AAEA;EACE,cAAA;EACA,uCAAA;EACA,uBAAA;EACA,gBAAA;AACF;AACE;EACE,qCAAA;EACA,sCAAA;EACA,cAAA;AACJ;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,mBAAA;EACA,oCAAA;EACA,qBAAA;EACA,2CAAA;AACF;;AAEA;EACE,cAAA;EACA,UAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;AACF;AACE;EACE,oCAAA;AACJ;;AAGA;EACE,0DAAA;EACA,0DAAA;EACA,sBAAA;EACA,aAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;AAAF;;AAGA;EACE,eAAA;EACA,SAAA;AAAF;;AAGA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,YAAA;EACA,+CAAA;EACA,WAAA;EACA,gBAAA;EACA,4BAAA;EACA,sCAAA;EACA,aAAA;AAAF;AAEE;EACE,wBAAA;AAAJ;AAGE;EACE,WAAA;EACA,kBAAA;AADJ;AAEI;EACE,oCAAA;AAAN;;AAKA,mBAAA;AACA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,oCAAA;EACA,aAAA;AAFF;;AAKA,+BAAA;AACA;EACE;IACE,wBAAA;EAFF;AACF","sourcesContent":[".navbar {\n  position: sticky;\n  top: 0;\n  z-index: 9999;\n  background-color: var(--e-global-color-primary);\n  color: var(--e-global-color-b7be4da);\n}\n\n.navbar-brand {\n  font-size: 1rem;\n  color: var(--e-global-color-b7be4da);\n}\n\n.nav-link {\n  color: var(--e-global-color-b7be4da);\n}\n\n.nav-link:hover {\n  color: var(--e-global-color-63d5b28);\n}\n\n.dropdown-menu {\n  background-color: #ffffff;\n  color: var(--e-global-color-text);\n  border: 1px solid rgba(0, 0, 0, 0.05);\n  border-radius: 12px;\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12);\n  padding: 6px;\n  min-width: 180px;\n}\n\n.dropdown-item {\n  color: var(--e-global-color-text);\n  border-radius: 10px;\n  padding: 10px 12px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n\n  &:hover {\n    background: #f7f8fb;\n    color: #111827;\n  }\n}\n\n.nav-action.app-button {\n  color: #ffffff;\n  border-color: rgba(255, 255, 255, 0.35);\n  background: transparent;\n  box-shadow: none;\n\n  &:hover {\n    background: rgba(255, 255, 255, 0.08);\n    border-color: rgba(255, 255, 255, 0.5);\n    color: #ffffff;\n  }\n}\n.nav-action__icon.app-button {\n  padding: 8px 10px;\n}\n\n.nav-action--filled.app-button {\n  background: #ffffff;\n  color: var(--e-global-color-primary);\n  border-color: #ffffff;\n  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.14);\n}\n\n.nav-close.app-button {\n  color: #ffffff;\n  padding: 0;\n  background: transparent;\n  border: none;\n  box-shadow: none;\n\n  &:hover {\n    color: var(--e-global-color-63d5b28);\n  }\n}\n\n.details-header-banner {\n  background-color: var(--e-global-color-primary) !important;\n  background: url('./../../../assets/event-image.png') no-repeat center center;\n  background-size: cover;\n  height: 300px;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 2rem;\n}\n\n.details-header-banner h1 {\n  font-size: 3rem;\n  margin: 0;\n}\n\n.mobile-sidenav {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 260px;\n  height: 100%;\n  background-color: var(--e-global-color-primary);\n  color: #fff;\n  overflow-y: auto;\n  transform: translateX(-100%);\n  transition: transform 0.3s ease-in-out;\n  z-index: 1050; // modálok alá, navbar fölé\n\n  &.open {\n    transform: translateX(0);\n  }\n\n  .nav-link {\n    color: #fff;\n    padding: 0.75rem 0;\n    &:hover {\n      color: var(--e-global-color-63d5b28);\n    }\n  }\n}\n\n/* háttér-overlay */\n.sidenav-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 1040;\n}\n\n/* rejtett-desktop nav-linkek */\n@media (max-width: 991.98px) {\n  .navbar .ml-auto {\n    display: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
